module.exports = __webpack_public_path__ + "img/stepper.53bdd227.svg";